import styled from 'styled-components'
import LeftBar from '../home/components/leftBar'
import Error from './error'

const Page = styled.div`
    display: flex;
    height: 100vh;
    overflow: hidden !important;
`

export default function ErrorPage() {
    return (
        <Page>
            <LeftBar />
            <Error />
        </Page>
    )
}
